<template>
  <operaciones-agua-resumen-tab-panel :model="props.data" :estructuraDocumental="props.estructuraDocumental" @documentoSubido="onDocumentoSubido" />
</template>

<script setup lang="ts">
import { messageBoxResult } from '@/.shared/components/dialogs/message-box';
import { useModalBuilder, type ToolbarReference } from '@/.shared/helpers/modal-building-helper';
import { useIntl } from '@/.shared/services/i18n/i18nservice';
import type { DxButton } from 'devextreme-vue';
import { getCurrentInstance, onMounted, reactive } from 'vue';
import OperacionesAguaResumenTabPanel from '@/components/operaciones-agua/OperacionesAguaResumenTabPanel.vue';
import { useApi } from '@api/integration';
import { TipoSuministroTramiteEnergiaEnum, type DetailOperacionAguaModel } from '@/.shared/.api';
import { useModalService } from '@/.shared/services/modal-service';
import { dangerButtonProps, primaryButtonProps } from '@/.shared/helpers/button-helper';
import { toastError, toastSuccess } from '@/.shared/services/notification-service';
import { CreateTicket } from '@/.shared/components/soporte/models/CreateTicket';
import TicketForm from '@/.shared/components/soporte/TicketForm.vue';

const props = defineProps(["data", "estructuraDocumental"]);
let model = reactive<DetailOperacionAguaModel>({} as DetailOperacionAguaModel);
const intl = useIntl();
const api = useApi();
const modalService = useModalService();

onMounted(async () => {
  model = props.data;
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!)

  configureButtons(modal);
});

const onDocumentoSubido = async() => {
  var response = await api.callStandardApi("getOperacionAguaDetail", { showLoading: true }, props.data.Id);
  Object.assign(model, response);
}

function configureButtons(modal: ReturnType<typeof useModalBuilder>) {
  addContactarSoporteButton(modal);
  addCloseButton(modal);
}

const addContactarSoporteButton = (modal: ReturnType<typeof useModalBuilder>) => {
  let soporteButton: ToolbarReference<DxButton>;
  soporteButton = modal.addButton("soporte", { ...primaryButtonProps(intl.i18n.t('operaciones.detalle.contactar_soporte')), 
      type: 'success', icon: "fa-thin fa-headset"}, { toolbar: "bottom", location: "before" });
  soporteButton.update(w => w.onClick = () => crearTicket());
}

const crearTicket = async () => {
  let title = `${intl.i18n.t("ticket.creacion.titulo")}`;
  const ticket = CreateTicket.CreateOperacionTicket(props.data?.Id!, props.data?.CodigoSecuencial?.toString() ?? '', 'AGUA');
  await modalService.showModal(
    TicketForm,
    { model: ticket },
    { title: title, width: 800, height: 700 }
  );
}


function addCloseButton(modal: ReturnType<typeof useModalBuilder>) {
  let closeButton: ToolbarReference<DxButton>;
  closeButton = modal.standardButtons.addClose();
  closeButton.update(w => w.onClick = () => modal.close(messageBoxResult.cancel));
}
</script>

<style lang="scss" scoped></style>